import axios from './axios'
import store from './store'
import liff from '@line/liff'

const DAYSTH = ['วันอาทิตย์', 'วันจันทร์', 'วันอังคาร', 'วันพุธ', 'วันพฤหัสบดี', 'วันศุกร์', 'วันเสาร์']
const DAYSEN = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
const MONTHSTH = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม']
const MONTHSEN = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

export default {
    months(currentLang) {
        let MONTHS = MONTHSEN
        if (currentLang === 'th') {
            MONTHS = MONTHSTH
        }
        return MONTHS
    },

    monthList(currentLang) {
        const data = []
        let MONTHS = MONTHSEN
        if (currentLang === 'th') {
            MONTHS = MONTHSTH
        }
        for (let i = 0; i < MONTHS.length; i++) {
            data.push({
                text: MONTHS[i],
                value: i
            })
        }
        return data
    },

    formatDate(date) {
        if (!date) {
            return null
        }

        const [year, month, day] = date.split('-')
        const BEYear = parseInt(year) + 543
        return `${day}/${month}/${BEYear}`
    },

    formatDateMonth(date) {
        if (!date) {
            return null
        }

        const dateVal = date.split('-')
        return `${dateVal[2]}/${dateVal[1]}`
    },

    getDateMonthByDateString(date) {
        if (!date) {
            return null
        }

        const dateVal = date.split('-')
        return {
            date: parseInt(dateVal[2]),
            month: parseInt(dateVal[1])
        }
    },

    formatTime(time) {
        return time.slice(0, 5)
    },

    datetoDateString(date, currentLang) {
        if (!date) {
            return null
        }
        let MONTHS = MONTHSEN
        let DAYS = DAYSEN
        if (currentLang === 'th') {
            DAYS = DAYSTH
            MONTHS = MONTHSTH
        }
        const day = date.getDay()

        const dayString = DAYS[day]

        const month = date.getMonth()
        const monthString = MONTHS[month]

        const year = date.getFullYear() + 543

        const dateNumber = date.getDate()

        return `${dayString} ${dateNumber} ${monthString} ${year}`
    },

    getFullMonnth(month, currentLang) {
        const MONTHS = month(currentLang)

        if (MONTHS[month]) {
            return MONTHS[month]
        }

        return '-'
    },

    dateStringToDateObj(dateString) {
        if (!dateString) {
            return null
        }

        const dateVal = dateString.split('/')
        const year = parseInt(dateVal[2]) - 543
        const month = parseInt(dateVal[1])
        const date = parseInt(dateVal[0])

        const dateObj = new Date()
        dateObj.setFullYear(year)
        dateObj.setDate(date)
        dateObj.setMonth(month - 1)
        dateObj.setHours(0)
        dateObj.setMinutes(0)
        dateObj.setSeconds(0)

        return dateObj
    },

    timeStringToMinute(v) {
        if (!v) {
            return 0
        }

        const [hourStr, minuteStr] = v.split(':')
        return (parseInt(hourStr, 10) * 60) + parseInt(minuteStr, 10)
    },

    formatNumber(amount) {
        if (typeof amount !== 'number') {
            throw new Error(`Invalid value, required number but found: ${typeof amount}`)
        }

        if (Number.isNaN(amount)) {
            throw new Error('Invalid value, found NaN')
        }

        const numStr = amount.toString().split('.')
        const len = numStr[0].length - 1
        let left = ''
        let counter = 0
        for (let i = len; i >= 0; i--) {
            left = numStr[0][i] + left
            counter++
            if (((counter % 3) === 0) && (i !== 0)) {
                left = ',' + left
            }
        }

        return numStr.length > 1 ? `${left}.${numStr[1]}` : left
    },

    async getDepartments() {
        let data = []
        const res = await axios.get('department/getAll')
        if (res && res.data && res.data.status === 'ok') {
            data = res.data.data
        }

        return data
    },

    async getGroups(branchId) {
        let data = []
        const res = await axios.get(`group/getAll?branch=${branchId}`)
        if (res && res.data && res.data.status === 'ok') {
            data = res.data.data
        }

        return data
    },

    checkPermission(permission) {
        return store.state.permissions.includes(permission)
    },

    downloadTextFile(fileData, filename) {
        const url = window.URL.createObjectURL(new Blob([fileData]))
        const link = document.createElement('a')

        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
    },

    downloadExcelFile(fileData, filename) {
        const url = window.URL.createObjectURL(new Blob([fileData]))
        const link = document.createElement('a')

        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
    },

    downloadPdfFile(fileData) {
        const blob = new Blob([fileData], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        window.open(url)
    },

    recheckValidate(listInput) {
        for (let i = 0; i < listInput.length; i++) {
            if (listInput[i].validations.length > 0) {
                listInput[i].validate()
            } else {
                listInput[i].resetValidation()
            }
        }
    },

    getLineOs() {
        return liff.getOS()
    },

    async getLineIdForLiff(liffId) {
        if (process.env.VUE_APP_NODE_ENV === 'development') {
            if ([process.env.VUE_APP_LINE_OT_APPROVAL_LIFF, process.env.VUE_APP_LINE_APPROVAL_LEAVE_LIFF, process.env.VUE_APP_LINE_ATTEN_APPROVAL_URL].includes(liffId)) {
                return 'Ua9eb9278a2a936cf8bdf2ab37d5f486a'
            }
            return 'Ueb870af53dfbffe083ef08e9718c6101'
        }

        await liff.init({ liffId: liffId }).catch(err => { throw err })
        const profile = await liff.getProfile()
        return profile.userId
    },

    async getLineIdToken(liffId) {
        await liff.init({ liffId: liffId }).catch(err => { throw err })
        const idToken = liff.getIDToken()
        return idToken
    },

    resetTimeout(key, fn, time) {
        if (window[key]) {
            clearTimeout(window[key])
        }

        window[key] = setTimeout(fn, time)
    },

    getCurrentDate() {
        // get current datetime and shift UTC to current client timezone for toISOString
        const now = new Date()
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset())
        return now.toISOString().substring(0, 10)
    },

    getNextYear(addYear = 1) {
        const now = new Date()
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset())
        now.setFullYear(now.getFullYear() + addYear)
        return now.toISOString().substring(0, 10)
    },

    getVersionLabel() {
        return `Version ${process.env.VUE_APP_VERSION ?? '1.17.1'} build 202601131746`
    }
}
